// extracted by mini-css-extract-plugin
export default {"downBox":"fileModal_downBox__GBsK-"};